import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Stepper, Step, StepLabel, Button, RadioGroup, FormControlLabel, Switch, Radio, CircularProgress, TextField, Table, TableHead, TableBody, TableRow, TableCell, ButtonGroup, FormGroup } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleStr, ADD, EDIT, VIEW, ONGOING, COMPLETED, DISABLED } from '../../../common/common';
import Toast from '../../Layout/components/Toast';
import UserAutoComplete from '../../Components/UserAutoComplete';
import RichText from '../../Components/RichText';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .page-title': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .text-field': {
        width: '50%',
        paddingRight: '15px',
    },
    '& .text-field-f': {
        width: '100%',
        // paddingRight: '15px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginLeft: '10px',
        },
    },
    '& .basic-status': {
        width: '110px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: 'gray'
    },
    '& .color-1': {
        backgroundColor: '#F7B500'
    },
    '& .color-2': {
        backgroundColor: '#18C6FF'
    },
    '& .color-3': {
        backgroundColor: 'gray'
    },
})

class TaskInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tasksData: [{
                id: '1',
                name: 'zhangsan',
                description: 'ddd',
                principal_id: 'p',
                principal_name: 'p name',
                reference_number: '234',
                result: '',
                status: ONGOING,
                create_time: '',
                update_time: '',
            }],
            personsData: [{
                id: '1',
                person_name: '',
                relation: '',
                is_existed: '',
            }],
            result: {
                is_existed: false,
                note: '',
            },
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.handleAlias = this.handleAlias.bind(this);
    }
    render() {
        const { title, data, state } = this.props;
        const {
            tasksData,
            personsData,
            result,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const noteView = () => {
            if (result.is_existed) {
                return <RichText
                    state={state}
                    data={result.note}
                    ref={(child) => { this.richText = child }}
                />
            }
        }
        const btns = () => {
            if (state !== VIEW) {
                return <div className="h">
                    <Button
                        className="btn"
                        variant="contained"
                        color="primary"
                        onClick={e => this.handleCreate(e, ONGOING)}
                    >
                        save
                    </Button>
                    <Button
                        className="btn"
                        variant="contained"
                        color="primary"
                        onClick={e => this.handleCreate(e, COMPLETED)}
                    >
                        submit
                    </Button>
                </div>
            }
        }
        const statusView = (status) => {
            if (status === ONGOING) {
                return <div className="basic-status color-1 c">Ongoing</div>
            } else if (status === COMPLETED) {
                return <div className="basic-status color-2 c">Completed</div>
            } else if (status === DISABLED) {
                return <div className="basic-status color-3 c">Disabled</div>
            } else {
                return <div>--</div>
            }
        }
        return (
            <Root>
                <div className="page-title">{title}</div>
                <div className="line"></div>
                <div className="title">Task Info</div>
                <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell>Task Name</TableCell>
                            <TableCell>Task desc</TableCell>
                            <TableCell>Principal</TableCell>
                            <TableCell>Result</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tasksData.map(row => (
                            <TableRow key={row.principal_id} role="checkbox">
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.description}</TableCell>
                                <TableCell>{row.principal_name}</TableCell>
                                <TableCell>{row.result}</TableCell>
                                <TableCell>{statusView(row.status)}</TableCell>
                            </TableRow>
                        ))}
                        {tasksData.length === 0 && (
                            <TableRow style={{ height: 300 }}>
                                <TableCell colSpan={12} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <div className="title">Person List</div>
                <Table stickyHeader className="table">
                    <TableHead>
                        <TableRow role="checkbox">
                            <TableCell>Person Name</TableCell>
                            <TableCell>Relation</TableCell>
                            <TableCell>Existed</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {personsData.map((row, index) => (
                            <TableRow key={index} role="checkbox">
                                <TableCell>{row.person_name}</TableCell>
                                <TableCell>{row.relation}</TableCell>
                                <TableCell>{row.is_existed ? "existed" : "no existed"}</TableCell>
                            </TableRow>
                        ))}
                        {personsData.length === 0 && (
                            <TableRow style={{ height: 300 }}>
                                <TableCell colSpan={12} />
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <div className="title">Result</div>
                <FormControlLabel
                    control={
                        <Switch
                            checked={result.is_existed}
                            onChange={this.handleAlias}
                            name="is_existed"
                            color="primary"
                        />
                    }
                    label="Primary"
                />
                {noteView()}
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button variant="contained" onClick={this.handleClose}>CANCEL</Button>
                    {btns()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        if (state !== ADD) {
            console.log(data)
            if (data) {
                this.setState({
                    tasksData: [{
                        id: '1',
                        name: data.name,
                        description: data.description ? data.description : '',
                        principal_id: data.principal_id ? data.principal_id : '',
                        principal_name: data.principal_name ? data.principal_name : '',
                        reference_number: data.reference_number ? data.reference_number : '',
                        status: data.status ? data.status : ONGOING,
                        update_time: data.update_time ? data.update_time : '',
                    }],
                    personsData: data.result instanceof Array ? data.result : [],
                })
            }
        }
    }
    updateMember(member) {
        if (!member) return;
        const user_ids = [];
        user_ids.push(member.id);
        this.setState({
            user_ids
        })
    }
    handleAlias(event) {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            result: {
                ...prevState.result,
                is_existed: isChecked,
            }
        }));
    }
    handleCreate(e, status) {
        const { result } = this.state;
        if (result.is_existed) {
            result.note = this.richText.getData();
        } else {
            result.note = "";
        }
        this.props.handleCreate(result, status);
    }
    handleClose() {
        this.props.handleCancel();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    //------------request-----------------
}

export default TaskInfo;